(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-footer"] && !Shopify.designMode) return;
  try {
    
(function() {
  const heroes = document.querySelectorAll('[data-bf-hero]');
  if (!heroes.length) return;
  if (!('IntersectionObserver' in window)) {
    heroes.forEach((h) => h.classList.add('is-visible'));
    return;
  }
  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (e.isIntersecting) {
        e.target.classList.add('is-visible');
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.2 });
  heroes.forEach((h) => io.observe(h));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-hero"] && !Shopify.designMode) return;
  try {
    
(function() {
  const heroes = document.querySelectorAll('[data-bh]');
  if (!heroes.length) return;
  // Mark loaded after first paint so the entrance animation kicks in
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      heroes.forEach((h) => h.classList.add('is-loaded'));
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-toggle-header"] && !Shopify.designMode) return;
  try {
    
(function() {
  const header = document.querySelector('[data-bth]');
  if (!header) return;

  const onScroll = () => {
    if (window.scrollY > 24) header.classList.add('is-scrolled');
    else header.classList.remove('is-scrolled');
  };
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });

  // Single-page brand toggle — html[data-brand] is the source of truth
  // (set before first paint by snippets/brand-mode.liquid)
  const BRANDS = ['campisi', 'robertos'];
  const applyBrand = (brand) => {
    document.documentElement.dataset.brand = brand;
    document.body.dataset.brand = brand;
    try { localStorage.setItem('rob-brand', brand); } catch (e) {}
    BRANDS.forEach(b => header.classList.remove('bth--' + b));
    header.classList.remove('bth--neutral');
    header.classList.add('bth--' + brand);
    header.querySelectorAll('[data-brand-switch]').forEach(btn => {
      const active = btn.dataset.brandSwitch === brand;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    document.dispatchEvent(new CustomEvent('brand:changed', { detail: { brand } }));
  };
  const setBrand = (brand, animate) => {
    if (!BRANDS.includes(brand)) return;
    if (!animate) { applyBrand(brand); return; }
    if (brand === document.documentElement.dataset.brand) return;
    // Off the homepage a flip would leave cross-brand content on screen
    // (e.g. a deli PDP under the butchery brand) — fade out and land home
    // instead; brand-mode.liquid picks the saved brand up before first paint.
    if (location.pathname !== '/') {
      try { localStorage.setItem('rob-brand', brand); } catch (e) {}
      const reducedNav = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!reducedNav) document.body.classList.add('brand-switching');
      setTimeout(() => { location.href = '/'; }, reducedNav ? 0 : 240);
      return;
    }
    const main = document.getElementById('MainContent') || document.querySelector('main');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!main || reduced || document.body.classList.contains('brand-switching')) {
      applyBrand(brand);
      window.scrollTo(0, 0);
      return;
    }
    // out: fade + slight scale-down (240ms) → flip while invisible → in (260ms)
    document.body.classList.add('brand-switching');
    setTimeout(() => {
      applyBrand(brand);
      window.scrollTo(0, 0);
      requestAnimationFrame(() => requestAnimationFrame(() => {
        document.body.classList.remove('brand-switching');
      }));
    }, 240);
  };

  header.querySelectorAll('[data-brand-switch]').forEach(btn => {
    btn.addEventListener('click', () => setBrand(btn.dataset.brandSwitch, true));
  });

  setBrand(document.documentElement.dataset.brand || 'campisi', false);

  // Update cart count on cart change events (fired by most theme cart drawers)
  document.addEventListener('cart:updated', (e) => {
    const count = e.detail && e.detail.cart && e.detail.cart.item_count;
    const el = header.querySelector('[data-bth-cart-count]');
    if (el && typeof count === 'number') el.textContent = count;
  });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-order-builder"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.querySelector('[data-cob]'); if(!root) return;
  var list=root.querySelector('[data-cob-list]'); var empty=root.querySelector('[data-cob-empty]');
  var totalEl=root.querySelector('[data-cob-total]'); var form=root.querySelector('[data-cob-form]');
  var success=root.querySelector('[data-cob-success]');
  var qtys={};
  function refresh(){
    var total=0, names=Object.keys(qtys).filter(function(k){return qtys[k]>0;});
    list.innerHTML='';
    if(names.length===0){ var li=document.createElement('li'); li.className='cob__empty'; li.textContent='Nothing added yet — set a quantity to start.'; list.appendChild(li); }
    names.forEach(function(n){ total+=qtys[n]; var li=document.createElement('li'); var a=document.createElement('span'); a.textContent=n; var b=document.createElement('span'); b.className='cob__li-qty'; b.textContent='×'+qtys[n]; li.appendChild(a); li.appendChild(b); list.appendChild(li); });
    totalEl.textContent=total;
  }
  root.querySelectorAll('[data-cob-item]').forEach(function(item){
    var name=item.getAttribute('data-name'); qtys[name]=0;
    var span=item.querySelector('[data-cob-qty]'); var q=item.querySelector('.cob__qty');
    item.querySelectorAll('[data-cob-q]').forEach(function(btn){
      btn.addEventListener('click',function(){
        qtys[name]=Math.max(0,qtys[name]+parseInt(btn.getAttribute('data-cob-q'),10));
        span.textContent=qtys[name]; q.classList.toggle('is-active',qtys[name]>0); refresh();
      });
    });
  });
  if(form) form.addEventListener('submit',function(e){ e.preventDefault(); if(success) success.hidden=false; success&&success.scrollIntoView({behavior:'smooth',block:'center'}); });
  refresh();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["deli-counter-tabs"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-dc]').forEach(function (section) {
    // Tab switching
    var tabs = section.querySelectorAll('[data-dc-tab]');
    var panels = section.querySelectorAll('[data-dc-panel]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) {
          var active = t === tab;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        panels.forEach(function (p) {
          if (p.dataset.dcPanel === tab.dataset.dcTab) p.removeAttribute('hidden');
          else p.setAttribute('hidden', '');
        });
      });
    });

    // Weight chips: select one, recompute the approximate total
    var GRAMS = { '100g': 100, '200g': 200, '300g': 300, '400g': 400, '500g': 500, '750g': 750, '1kg': 1000, '1.5kg': 1500, '2kg': 2000 };
    section.querySelectorAll('[data-dc-card]').forEach(function (card) {
      var per100 = parseFloat(card.dataset.pricePer100g) || 0;
      var total = card.querySelector('[data-dc-total]');
      card.querySelectorAll('[data-dc-weight]').forEach(function (chip) {
        chip.addEventListener('click', function () {
          card.querySelectorAll('[data-dc-weight]').forEach(function (c) {
            c.classList.toggle('is-selected', c === chip);
          });
          if (per100 > 0 && total) {
            var grams = GRAMS[chip.dataset.dcWeight] || parseInt(chip.dataset.dcWeight, 10) || 0;
            if (grams > 0) {
              total.textContent = '≈ $' + (per100 * grams / 100).toFixed(2);
            }
          }
        });
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["editorial-hero"] && !Shopify.designMode) return;
  try {
    
(function() {
  const heroes = document.querySelectorAll('[data-eh]');
  if (!heroes.length) return;
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      heroes.forEach((h) => h.classList.add('is-loaded'));
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-explorer"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-pex]').forEach(function (root) {
    var grid = root.querySelector('[data-pex-grid]');
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-pex-item]'));
    var filters = Array.prototype.slice.call(root.querySelectorAll('[data-pex-filter]'));
    var allBtn = root.querySelector('[data-pex-all]');
    var search = root.querySelector('[data-pex-search]');
    var countEl = root.querySelector('[data-pex-count]');
    var clearBtn = root.querySelector('[data-pex-clear]');
    var emptyEl = root.querySelector('[data-pex-empty]');
    var resetBtn = root.querySelector('[data-pex-reset]');
    var active = new Set();
    var total = items.length;

    function apply() {
      var q = (search && search.value || '').trim().toLowerCase();
      var shown = 0;
      items.forEach(function (el) {
        var cat = el.getAttribute('data-category') || '';
        var name = el.getAttribute('data-name') || '';
        var matchCat = active.size === 0 || active.has(cat);
        var matchText = q === '' || name.indexOf(q) > -1 || cat.indexOf(q) > -1;
        var show = matchCat && matchText;
        el.hidden = !show;
        if (show) shown++;
      });
      if (countEl) countEl.textContent = shown === total ? total + ' items' : shown + ' of ' + total + ' items';
      var filtering = active.size > 0 || q !== '';
      if (clearBtn) clearBtn.hidden = !filtering;
      if (emptyEl) emptyEl.hidden = shown !== 0;
      if (allBtn) {
        var allActive = active.size === 0;
        allBtn.classList.toggle('is-active', allActive);
        allBtn.setAttribute('aria-pressed', allActive ? 'true' : 'false');
      }
    }

    filters.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var val = btn.getAttribute('data-pex-filter');
        if (active.has(val)) { active.delete(val); btn.classList.remove('is-active'); btn.setAttribute('aria-pressed', 'false'); }
        else { active.add(val); btn.classList.add('is-active'); btn.setAttribute('aria-pressed', 'true'); }
        apply();
      });
    });

    function clearAll() {
      active.clear();
      filters.forEach(function (b) { b.classList.remove('is-active'); b.setAttribute('aria-pressed', 'false'); });
      if (search) search.value = '';
      apply();
    }
    if (allBtn) allBtn.addEventListener('click', clearAll);
    if (clearBtn) clearBtn.addEventListener('click', clearAll);
    if (resetBtn) resetBtn.addEventListener('click', clearAll);
    if (search) search.addEventListener('input', apply);

    // Pre-filter from URL: ?category=cheese (comma-separated) or #cheese
    function preselect() {
      var vals = [];
      try {
        var params = new URLSearchParams(window.location.search);
        var c = params.get('category');
        if (c) vals = c.split(',');
        var q = params.get('q');
        if (q && search) search.value = q;
      } catch (e) {}
      var hash = (window.location.hash || '').replace('#', '');
      if (hash && hash !== 'shop') vals.push(hash);
      vals.forEach(function (v) {
        v = v.trim().toLowerCase();
        var btn = root.querySelector('[data-pex-filter="' + v + '"]');
        if (btn && !active.has(v)) {
          active.add(v);
          btn.classList.add('is-active');
          btn.setAttribute('aria-pressed', 'true');
        }
      });
    }
    preselect();
    apply();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.querySelector('[data-pl]'); if(!root) return;
  var grid=root.querySelector('[data-pl-grid]');
  var cards=[].slice.call(grid.querySelectorAll('.pl__card'));
  var search=root.querySelector('[data-pl-search]');
  var sortSel=root.querySelector('[data-pl-sort]');
  var filterToggle=root.querySelector('[data-pl-filter-toggle]');
  var filters=root.querySelector('[data-pl-filters]');
  var filterCount=root.querySelector('[data-pl-filter-count]');
  var count=root.querySelector('[data-pl-count]');
  var empty=root.querySelector('[data-pl-empty]');
  var reset=root.querySelector('[data-pl-reset]');
  var pager=root.querySelector('[data-pl-pager]');
  var per=parseInt(root.getAttribute('data-per'),10)||24;
  var page=1, filtered=[];

  function brand(){ return document.documentElement.dataset.brand==='campisi'?'campisi':'robertos'; }
  function fset(){ return root.querySelector('.pl__fset--'+brand()); }
  function activeCats(){ return [].slice.call(fset().querySelectorAll('[data-cat-filter]:checked')).map(function(b){return b.getAttribute('data-cat-filter');}); }
  function activeSubs(){ return [].slice.call(fset().querySelectorAll('[data-sub-filter]:checked')).map(function(b){return b.getAttribute('data-sub-filter');}); }

  function compute(){
    var br=brand(), t=(search.value||'').trim().toLowerCase(), cats=activeCats(), subs=activeSubs();
    filtered=cards.filter(function(c){
      if(c.getAttribute('data-brand')!==br) return false;
      var mc=cats.length===0||cats.indexOf(c.getAttribute('data-cat'))>-1;
      var ms=subs.length===0||subs.indexOf(c.getAttribute('data-sub'))>-1;
      var mt=t===''||c.getAttribute('data-name').indexOf(t)>-1;
      return mc&&ms&&mt;
    });
    var s=sortSel.value;
    if(s!=='featured'){ filtered.sort(function(a,b){
      if(s.indexOf('name')===0){ var an=a.getAttribute('data-name'),bn=b.getAttribute('data-name'); return s==='name-asc'?an.localeCompare(bn):bn.localeCompare(an); }
      var ap=parseFloat(a.getAttribute('data-price')),bp=parseFloat(b.getAttribute('data-price')); return s==='price-asc'?ap-bp:bp-ap; });
    } else { filtered.sort(function(a,b){return (+a.getAttribute('data-i'))-(+b.getAttribute('data-i'));}); }
    var fc=cats.length+subs.length;
    if(filterCount){ filterCount.hidden=fc===0; filterCount.textContent=fc; }
    page=1; render();
  }
  function render(){
    var total=filtered.length, pages=Math.max(1,Math.ceil(total/per));
    if(page>pages)page=pages;
    var start=(page-1)*per, end=start+per;
    cards.forEach(function(c){c.hidden=true;});
    grid.innerHTML='';
    filtered.slice(start,end).forEach(function(c){c.hidden=false; grid.appendChild(c);});
    if(empty) empty.hidden=total!==0;
    if(count) count.textContent = total===0 ? 'No items' : ('Showing '+(start+1)+'–'+Math.min(end,total)+' of '+total+' items');
    renderPager(pages);
  }
  function pgBtn(label,p,opts){ opts=opts||{}; var b=document.createElement('button'); b.type='button'; b.className='pl__pg'+(opts.active?' is-active':''); b.textContent=label; if(opts.disabled)b.disabled=true; if(!opts.disabled&&!opts.active)b.addEventListener('click',function(){page=p;render();root.scrollIntoView({behavior:'smooth'});}); return b; }
  function renderPager(pages){ pager.innerHTML=''; if(pages<=1) return;
    pager.appendChild(pgBtn('‹',page-1,{disabled:page===1}));
    var nums=[]; for(var i=1;i<=pages;i++){ if(i===1||i===pages||(i>=page-1&&i<=page+1)) nums.push(i); else if(nums[nums.length-1]!=='…') nums.push('…'); }
    nums.forEach(function(n){ if(n==='…'){ var s=document.createElement('span'); s.className='pl__pg-gap'; s.textContent='…'; pager.appendChild(s); } else pager.appendChild(pgBtn(String(n),n,{active:n===page})); });
    pager.appendChild(pgBtn('›',page+1,{disabled:page===pages})); }

  search.addEventListener('input',compute);
  sortSel.addEventListener('change',compute);
  root.querySelectorAll('[data-cat-filter]').forEach(function(b){ b.addEventListener('change',function(){
    if(b.checked){ var p=b.getAttribute('data-cat-filter'); root.querySelectorAll('[data-sub-filter][data-parent="'+p+'"]').forEach(function(s){s.checked=false;}); }
    compute(); }); });
  root.querySelectorAll('[data-sub-filter]').forEach(function(b){ b.addEventListener('change',function(){
    if(b.checked){ var p=b.getAttribute('data-parent'); var cb=root.querySelector('[data-cat-filter="'+p+'"]'); if(cb)cb.checked=false; }
    compute(); }); });
  if(filterToggle) filterToggle.addEventListener('click',function(){ var open=!filters.hidden; filters.hidden=open; filterToggle.setAttribute('aria-expanded',open?'false':'true'); });
  var fc2=root.querySelector('[data-pl-filter-close]'); if(fc2) fc2.addEventListener('click',function(){ filters.hidden=true; filterToggle.setAttribute('aria-expanded','false'); });
  function clearAll(){ root.querySelectorAll('[data-cat-filter],[data-sub-filter]').forEach(function(b){b.checked=false;}); search.value=''; sortSel.value='featured'; compute(); }
  var clr=root.querySelector('[data-pl-clear]'); if(clr)clr.addEventListener('click',clearAll);
  if(reset)reset.addEventListener('click',clearAll);

  // re-filter when the brand toggle flips
  document.addEventListener('brand:changed', function(){ clearAll(); });

  // deep links
  try{ var p=new URLSearchParams(location.search).get('category'); if(p){ p.split(',').forEach(function(v){ v=v.trim().toLowerCase(); var cb=root.querySelector('[data-cat-filter="'+v+'"]'); if(cb)cb.checked=true; }); } }catch(e){}
  try{ var qq=new URLSearchParams(location.search).get('q'); if(qq){ search.value=qq; } }catch(e){}

  compute();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-page-demo"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-pdp]').forEach(function (root) {
    var frames = root.querySelectorAll('[data-pdp-frame]');
    var thumbs = root.querySelectorAll('[data-pdp-thumb]');
    var current = 0;

    function show(i) {
      current = (i + frames.length) % frames.length;
      frames.forEach(function (f, idx) { f.classList.toggle('is-active', idx === current); });
      thumbs.forEach(function (t, idx) { t.classList.toggle('is-active', idx === current); });
    }
    thumbs.forEach(function (t, idx) {
      t.addEventListener('click', function () { show(idx); });
    });
    var prev = root.querySelector('[data-pdp-prev]');
    var next = root.querySelector('[data-pdp-next]');
    if (prev) prev.addEventListener('click', function () { show(current - 1); });
    if (next) next.addEventListener('click', function () { show(current + 1); });

    // price = per100g × grams × qty
    var GRAMS = { '100g': 100, '200g': 200, '300g': 300, '400g': 400, '500g': 500, '750g': 750, '1kg': 1000, '1.5kg': 1500, '2kg': 2000 };
    var per100 = parseFloat(root.dataset.pricePer100g) || 0;
    var qty = 1;
    var grams = 100;
    var totalEl = root.querySelector('[data-pdp-total]');
    var qtyEl = root.querySelector('[data-pdp-qty-display]');
    var weightLabel = root.querySelector('[data-pdp-weight-label]');

    function update() {
      if (qtyEl) qtyEl.textContent = qty;
      if (totalEl && per100 > 0) {
        totalEl.textContent = '$' + (per100 * grams / 100 * qty).toFixed(2);
      }
    }

    root.querySelectorAll('[data-pdp-weight]').forEach(function (chip) {
      chip.addEventListener('click', function () {
        root.querySelectorAll('[data-pdp-weight]').forEach(function (c) {
          c.classList.toggle('is-selected', c === chip);
        });
        grams = GRAMS[chip.dataset.pdpWeight] || parseInt(chip.dataset.pdpWeight, 10) || 100;
        if (weightLabel) weightLabel.textContent = chip.dataset.pdpWeight;
        update();
      });
    });
    root.querySelectorAll('[data-pdp-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        qty = Math.min(20, Math.max(1, qty + parseInt(btn.dataset.pdpQty, 10)));
        update();
      });
    });

    var cartBtn = root.querySelector('[data-pdp-cart]');
    var note = root.querySelector('[data-pdp-note]');
    if (cartBtn && note) {
      cartBtn.addEventListener('click', function () {
        note.hidden = false;
      });
    }

    update();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-shelf"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-ps]').forEach(function (root) {
    var track = root.querySelector('[data-ps-track]');
    if (!track) return;
    var prev = root.querySelector('[data-ps-prev]');
    var next = root.querySelector('[data-ps-next]');
    function step() {
      var cell = track.querySelector('.ps__cell');
      return cell ? (cell.offsetWidth + 20) * 2 : 560;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-carousel"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-pcar]').forEach(function (root) {
    var slides = root.querySelectorAll('[data-pcar-slide]');
    if (slides.length < 2) return;
    var dots = root.querySelectorAll('[data-pcar-dot]');
    var current = 0;
    var timer = null;
    var delay = (parseInt(root.dataset.autoplay, 10) || 4) * 1000;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // animate the progress fill on the active dot over the autoplay interval
    function animateFill() {
      dots.forEach(function (d, idx) {
        var fill = d.querySelector('.pcar__dot-fill');
        if (!fill) return;
        fill.style.transition = 'none';
        fill.style.width = '0%';
        void fill.offsetWidth; // reflow
        if (idx === current && !reduced) {
          fill.style.transition = 'width ' + delay + 'ms linear';
          fill.style.width = '100%';
        }
      });
    }
    function freezeFills() {
      dots.forEach(function (d) {
        var fill = d.querySelector('.pcar__dot-fill');
        if (!fill) return;
        var w = getComputedStyle(fill).width;
        fill.style.transition = 'none';
        fill.style.width = w;
      });
    }
    function go(i) {
      current = (i + slides.length) % slides.length;
      slides.forEach(function (s, idx) { s.classList.toggle('is-active', idx === current); });
      dots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === current); });
      animateFill();
    }
    function restart() {
      if (reduced) return;
      clearInterval(timer);
      timer = setInterval(function () { go(current + 1); }, delay);
    }

    var prev = root.querySelector('[data-pcar-prev]');
    var next = root.querySelector('[data-pcar-next]');
    if (prev) prev.addEventListener('click', function () { go(current - 1); restart(); });
    if (next) next.addEventListener('click', function () { go(current + 1); restart(); });
    dots.forEach(function (d, idx) {
      d.addEventListener('click', function () { go(idx); restart(); });
    });

    // swipe
    var startX = null;
    root.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 48) { go(current + (dx < 0 ? 1 : -1)); restart(); }
      startX = null;
    }, { passive: true });

    animateFill();
    restart();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
